import Rout from './Route/Route';
import './App.css';

function App() {
  return (
    <div className="App">
<Rout/>
    </div>
  );
}

export default App;
